import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PageMenuItem = styled(FontAwesomeIcon)`
  margin-right: 4px;
`;

export default PageMenuItem;
